<template>
  <v-form>
    <v-container>
      <v-row no-gutters>
        <v-col>
          <v-radio-group v-model="formData.type" row>
            <v-radio label="Cheque" value="cheque" />
            <v-radio label="Bank Slip" value="bank_slip" />
          </v-radio-group>

          <v-text-field
            :disabled="payload.amount > 0"
            v-model="formData.amount"
            dense
            outlined
            label="Amount"
            type="number"
          />

          <v-row dense v-if="isCheque">
            <v-col cols="12" md="6">
              <v-text-field
                dense
                outlined
                v-model="formData.accountName"
                label="Account Name"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                dense
                outlined
                v-model="formData.accountNo"
                label="Account Number"
              />
            </v-col>
          </v-row>

          <v-row dense v-if="isCheque">
            <v-col cols="12" md="6">
              <v-text-field
                dense
                outlined
                v-model="formData.chequeNo"
                label="Cheque Number"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                dense
                outlined
                v-model="formData.chequeDate"
                label="Deposit Date"
                type="date"
              />
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" md="12">
              <v-text-field
                dense
                outlined
                v-model="formData.bankName"
                label="Bank name"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                dense
                outlined
                v-model="formData.bankBranch"
                label="Bank Branch"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                dense
                outlined
                v-model="formData.bankCode"
                label="Bank Code"
              />
            </v-col>
          </v-row>

          <v-file-input
            prepend-inner-icon="mdi-attachment"
            prepend-icon=""
            dense
            outlined
            v-model="formData.attachment"
            accept="image/*"
            label="Cheque/EFT Attachment"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
export default {
  name: "Cheque",
  props: {
    payload: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      formData: {
        type: "cheque",
        accountNo: "",
        accountName: "",
        bankName: "",
        bankBranch: "",
        bankCode: "",
        chequeNo: "",
        chequeDate: "",
        amount: "",
        attachment: [],
      },
    };
  },

  computed: {
    isCheque() {
      return this.formData.type === "cheque";
    },
  },

  mounted() {
    Event.$on("checkout-1", () => {
      this.pay();
    });
  },

  methods: {
    pay: function () {
      let data = { ...this.payload, ...this.formData };

      let formData = new FormData();
      for (let key in data) {
        if (data[key] === null) data[key] = "";
        formData.append(key, data[key]);
      }

      this.$store.dispatch("Checkout/chequePayment", formData);
    },
  },
  watch: {
    payload: {
      handler: function () {
        this.formData.amount = this.payload.amount;
        this.formData.accountNo = this.payload.accountNo;
      },
      immediate: true,
    },
  },
};
</script>

<style scoped></style>
